module.exports = __webpack_public_path__ + "img/dog-bowl.a43505b8.svg";